export const defaultInputType = 'text';
